var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveNotActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.743,
    height: 18.207,
    viewBox: "0 0 13.743 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860",
    transform: "translate(-429.668 -85.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M9245.436-10053.793a1.4,1.4,0,0,1-.156-.009,1.453,1.453,0,0,1-.913-.471,1.434,1.434,0,0,1-.366-.955v-15.336a1.443,1.443,0,0,1,.379-.971,1.417,1.417,0,0,1,.938-.46c.042,0,.075-.006.105-.006h.041a1.419,1.419,0,0,1,.809.258l10.864,7.672a1.438,1.438,0,0,1,.606,1.173,1.434,1.434,0,0,1-.4.994,1.448,1.448,0,0,0-.332-.036h-5.123a1.411,1.411,0,0,0-1.408,1.41,1.41,1.41,0,0,0,1.408,1.408h1.557l-7.174,5.061A1.432,1.432,0,0,1,9245.436-10053.793Z",
    transform: "translate(-8814.332 10157.383)",
    fill: "#6689e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18348",
    "data-name": "Path 18348",
    d: "M436.34,367.259h-1.682l2.48-3.384a1.007,1.007,0,0,0,.084-1.03.962.962,0,0,0-.883-.525h-3.594a.988.988,0,0,0,0,1.976h1.682l-2.48,3.363a1.007,1.007,0,0,0-.084,1.03.962.962,0,0,0,.883.525h3.615a.987.987,0,0,0,.988-.988A1.016,1.016,0,0,0,436.34,367.259Z",
    transform: "translate(5.442 -266.419)",
    fill: "#6689e0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveNotActive);
export default __webpack_public_path__ + "static/media/live_not_active.1dcd69923c00df0181448c8725deeb3e.svg";
export { ForwardRef as ReactComponent };